import axiosInstance from 'axios-config';

export const fetchURLs = async (authHeader, query = '') => {
  try {
    const response = await axiosInstance.get('/url/allocate/' + query,
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const getAllCategoriesFromDb = async (authHeader) => {
  try {
    const response = await axiosInstance.get('/category/',
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const getAllocatedUrls = async (authHeader) => {
  try {
    const response = await axiosInstance.get('/url/assigned/',
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const saveUpdatedUrlToDb = async (authHeader, id, payload) => {
  try {
    const response = await axiosInstance.put(`/url/save/${id}/`, payload,
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const getUrlDiffData = async (authHeader) => {
  try {
    const response = await axiosInstance.get('/url/review_category/',
      { headers: authHeader });
    return response;
  } catch (error) {
    console.log(error);
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    if (status == 401) {
      let response = {};
      response.erroe = error;
      response.status = status
      return response
    } else return null;
  };
};

export const sendPublishedResultsToDb = async (payload, authHeader) => {
  try {
    const response = await axiosInstance.post('/url/urldb_results/', JSON.parse(payload),
      { headers: authHeader });
    return response;
  } catch (error) {
    let response = {};
    let _s = error.message.split(' ')
    let status = parseInt(_s[_s.length - 1])
    response.erroe = error;
    console.log(error);
    if (status == 401) {
      response.status = status
      return response
    } else if (status == 400) {
      response.status = status
      return response
    } else return null;
  };
};

export const publishUrls = async (payload, location) => {
  window.location.href = `${process.env.REACT_APP_PORTAL_API}/tools/uridb_wpv_publish/?return_uri=${location}&uri_details=${JSON.stringify(payload)}`
};
